/*global Circles */
/* STATISTICS */

define(['libraries/circles'], function () {   
    var renderCircles = {
        $circles: [],
        colors: function (primaryColour){
            var colourPalette = [];
            switch (primaryColour) {
                case "pink-pale-blue":
                    colourPalette = ["#D8E0EC", Utilities.colors.pink, Utilities.colors.pink, Utilities.colors.white];
                    break;
                case "violet-gradient-pale-pink":
                    colourPalette = ["rgba(152,40,129,0.2)", "#632678", "#632678", Utilities.colors.white];
                    break;
                case "pink":
                    colourPalette = [Utilities.colors.pink, Utilities.colors.violet, Utilities.colors.violet, Utilities.colors.white];
                    break;
                case "purple":
                    colourPalette = [Utilities.colors.purple, Utilities.colors.pink, Utilities.colors.pink, Utilities.colors.white];
                    break;                
                default: // blue-dark
                    colourPalette = [Utilities.colors.medium_grey, Utilities.colors.dark_blue, Utilities.colors.dark_blue, Utilities.colors.white];
                    break;
            }

            return colourPalette;
        },
        createCircle: function(i, $circle) {
            
            var circle = Circles.create({
                id: $circle.attr('id'),
                value: $circle.attr('data-displayvalue'),
                maxValue: $circle.attr('data-maxvalue'),
                prefix: $circle.attr('data-prefix'),
                suffix: $circle.attr('data-suffix'),
                duration: $circle.attr('data-duration'),
                text: $circle.attr('data-textvalue'),
                colors: this.colors($circle.attr('data-color')),
                textClass: 'statistics-number',
                radius: this.calculateRadius($circle.parent()),
                width: this.calculateWidth($circle)
            });

            this.circles[i] = circle;
        },
        init: function () {
            var self = this;
            self.circles = [];
            self.$circles = $('.statistics-container .circle');
            
            if (self.$circles.length > 0) {

                // Initialise each circle. Give it a sequential ID for use within the global 'circles' array
                self.$circles.each(function (i) {
                    
                    var $circle = $(this);

                    var colorindex = 2;
                    
                    $circle.attr('id', 'circles-' + i);
                    $circle.attr('data-colorindex', colorindex);

                    // Animate each circle as it enters the viewport
                    $circle.inView(function () {
                        self.loadCircle($circle);
                    });
                });

                self.bindResize();
            }
        },

        bindResize: function () {
            var self = this;
            // Update circles' radii when window size changes
            $(window).on('resize', function () {
                $.each(self.circles, function (i, circle) {
                    if (circle) {
                        var newRadius = self.calculateRadius(self.$circles.eq(i).parent());
                        if (!Number.isNaN(newRadius)) {
                            circle.updateRadius(newRadius);
                        }

                        // Update the circles' stroke width
                        circle.updateWidth(self.calculateWidth(self.$circles.eq(i)));
                    }
                });
            });
        },

        loadCircle: function ($circle) {
            var self = this;
            
            var id = $circle.attr('id').replace('circles-', '');
            if (typeof self.circles[id] === 'undefined') {
                self.createCircle(id, $circle);
            }
        },

        calculateRadius: function ($parent) {
            var divisor = 2;
            var margin = 30;
            var hasSibling = $parent.children().length > 1;

            // Small screens (sometimes) display the circle stat next to the text, hence it needs to be smaller.
            // This is only the case if the stat has a sibling that is a text box.
            if (window.innerWidth <= Utilities.breakpoint.xs && hasSibling) {
                divisor = 4;
            }

            return $parent.width() / divisor - margin;
        },

        calculateWidth: function ($circle) {
            var strokeWidth = 25;
            var $parent = $circle.parent();
            var hasSibling = $parent.children().length > 1;

            if ($circle.attr('data-color') === "pink-pale-blue"){
                strokeWidth = 16;

                if (window.innerWidth <= Utilities.breakpoint.xs && hasSibling) {
                    strokeWidth = 12;
                }
                return strokeWidth;
            }

            // If the stat has a sibling displayed next to it (and will therefore be smaller), we need to decrease the width
            if (window.innerWidth <= Utilities.breakpoint.xs && hasSibling) {
                strokeWidth = 15;
            }

            return strokeWidth;
        }
    };    
    
    $(function(){
        renderCircles.init();    
    });
    
    return renderCircles;   
});